import Inicio from "./pages/Inicio/Inicio";
import Reserva from "./pages/Reserva";
import TakeawayDisplay from "./pages/TakeawayDisplay/TakeawayDisplay";
import { Route, Routes } from "react-router-dom";

function LandingDomain() {
  return (
    <Routes>
      <Route path="/" element={<Inicio />} />
      <Route path="/reserva" element={<Reserva />} />
      <Route path="/takeaway-bg-display" element={<TakeawayDisplay />} />
    </Routes>
  );
}

export default LandingDomain;
